const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * STOCK ALERT EVENTS                                                         *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.stockAlertClosed, () => {
    pushEvent(
      createCustomEventGA4('product_availability_alert', [['action', 'close']])
    );
  });

  analyticsEventBus.subscribe(ANALYTICS_EVENTS.stockAlertOpened, () => {
    pushEvent(
      createCustomEventGA4('product_availability_alert', [['action', 'open']])
    );
  });

  analyticsEventBus.subscribe(ANALYTICS_EVENTS.stockAlertSent, () => {
    pushEvent(
      createCustomEventGA4('product_availability_alert', [['action', 'send']])
    );
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
